<div
  class="px-1 py-[2px] flex-none rounded-[4px] flex gap-[2px] items-center justify-center"
  [ngClass]="{ 'bg-success-100': positive, 'bg-critical-100': !positive }"
  *ngIf="percent"
>
  <ui-icon
    size="12"
    m-size="12"
    [attr.name]="positive ? 'arrow-up' : 'arrow-down'"
    [attr.fill]="positive ? 'success-300' : 'critical-300'"
  />
  <ui-paragraph
    type="p10"
    mobile-type="p10"
    font-weight="semibold"
    [attr.text-color]="positive ? 'success-300' : 'critical-300'"
  >
    {{ percent }}% vs periodo anterior
  </ui-paragraph>
</div>
